import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Save, Loader2 } from 'lucide-react';
import { client } from './AuthContext';

const fields = [
  { key: 'brand_name', label: 'Nama Brand' },
  { key: 'tagline', label: 'Tagline' },
  { key: 'logo_url', label: 'URL Logo' },
  { key: 'whatsapp_number', label: 'Nomor WhatsApp (628…)' },
  { key: 'whatsapp_display', label: 'WhatsApp Ditampilkan' },
  { key: 'whatsapp_message', label: 'Pesan Default WhatsApp', textarea: true },
  { key: 'whatsapp_hours', label: 'Jam Operasional' },
  { key: 'hotline', label: 'Nomor Hotline' },
];

const empty = fields.reduce((a, f) => ({ ...a, [f.key]: '' }), {});

export default function AdminConfig() {
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    client
      .get('/api/site/config')
      .then((r) => setForm({ ...empty, ...r.data }))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await client.put('/api/admin/site/config', form);
      toast.success('Konfigurasi tersimpan');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Gagal menyimpan');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-config-page">
      <p className="text-xs tracking-[0.25em] text-px-red font-semibold mb-3">
        KONFIGURASI SITE
      </p>
      <h1 className="font-display text-4xl font-bold text-neutral-900 mb-2">
        Konfigurasi Site
      </h1>
      <p className="text-neutral-600 mb-8">
        Nama brand, logo, dan kontak yang tampil di seluruh halaman.
      </p>

      <form
        onSubmit={save}
        className="bg-white rounded-2xl border border-neutral-200 p-8 space-y-5"
      >
        {fields.map((f) => (
          <div key={f.key}>
            <label className="text-xs uppercase tracking-wider text-neutral-600 font-semibold">
              {f.label}
            </label>
            {f.textarea ? (
              <textarea
                rows={3}
                value={form[f.key] || ''}
                onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                data-testid={`config-${f.key}`}
                className="mt-2 w-full bg-neutral-50 border border-neutral-200 focus:border-neutral-900 outline-none rounded-xl px-4 py-3 text-sm resize-none"
              />
            ) : (
              <input
                value={form[f.key] || ''}
                onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                data-testid={`config-${f.key}`}
                className="mt-2 w-full bg-neutral-50 border border-neutral-200 focus:border-neutral-900 outline-none rounded-xl px-4 py-3 text-sm"
              />
            )}
          </div>
        ))}

        <button
          type="submit"
          disabled={saving || !loaded}
          data-testid="config-save-btn"
          className="inline-flex items-center gap-2 bg-px-red hover:bg-red-700 disabled:opacity-60 text-white font-semibold px-7 py-3 rounded-full transition-colors"
        >
          {saving ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" /> Menyimpan...
            </>
          ) : (
            <>
              <Save className="w-4 h-4" /> Simpan Perubahan
            </>
          )}
        </button>
      </form>
    </div>
  );
}
